export default function (office) {
  return {
    id: office.id,
    name: `#${office.storeNum} - ${office.address} (${office.efin})`,
  };
}
